import { defineStore } from 'pinia'
import { toRaw } from 'vue'

export const useVisualizationsStore = defineStore('vis', {
    state: () => ({
        currentPage: '',
        arrindicators:[],
        loading: false,
        pages: [],
        currentPage: '',
        currentIdx: 0,
        pageNames: [],
        selectedIndicator: null,
        selectedIndicatorId: null,
        selectedIndicatorStr: "",
        selectedIndicatorSlug: "",
        chartType: '',
        user: {},
        arrhospitals:[],
        arrstates: [],
        years: [],
        groups:[],
        defaultYear:0,
        arrData: [],
        params: {},
        domains:[],
        selectedHospitalId: "",
        selectedHospitalName: "",
        
    }),
    actions: {
        setUser(user) {
            this.user = user
        },
        setChartType(chartType) {
            this.chartType = chartType
        },
        setYears(years) {
            this.years = years.replace("[", "").replace("]", "").split(",")
        },
        setDefaultYear(defaultYear) {
            this.defaultYear = defaultYear
        },
        setDomains(domains) {
            this.domains = domains.replace("[", "").replace("]", "").replaceAll("\"", "").split(",")
        },
        loadPages(pages) {
            this.pageNames = []
            this.pages = []
            for (var key in pages) {
                this.pageNames.push( key )
                this.pages.push( pages[key] )
            }
        },
        loadPage(page_name) {
            this.loading = true;
            if ( page_name !== undefined && page_name != null) {
                 
                var index = this.pageNames.indexOf(page_name)
                this.currentPage = page_name
                this.currentIdx = index
            } else {
                this.currentIdx = 0;
                this.currentPage = this.pageNames[this.currentIdx]
            }
            this.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

            this.loading = false;
        },
        setPage(page) {
            this.currentPage = page;
        },
        setIndicator(indicator){
            this.selectedIndicatorId = indicator.id;
            this.setIndicatorData()
            if(this.selectedIndicatorId !== null) {
                if (this.user.typecode == 'federal') {
                    this.loadPage('fgroups');  
                } else if (this.user.typecode == 'state') {
                    this.loadPage('fgroups');  
                } else {
                    this.loadPage('hgroups'); 
                }
                
            }
        },
        setHospitalId(cahid, hospital_name){
            this.selectedHospitalId = cahid;
            this.selectedHospitalName = hospital_name;
            this.loadPage('percentilesvis'); 
        },
        restart() {
            // if (this.chartType == 'fdi' && this.user.typecode == 'hospital') {
            //     window.location.href = './vistype';
            // } else if ( this.chartType == 'fdi' ) {
            //   window.location.href = './financial_indicator?chart_type='+this.chartType;  
            // } else {
            //   window.location.href = './bar_and_line?chart_type='+this.chartType;  
            // }
            // always to go vistype when 'start new graph'
            window.location.href = './vistype';
            
        },
        changeCompGroup() {
            if (this.user.typecode == 'federal') {
                this.loadPage('fgroups');  
            } else if (this.user.typecode == 'state') {
                this.loadPage('fgroups');  
            } else {
                this.loadPage('hgroups'); 
            }
        },
        changeIndicator() {
            this.loadPage('indicators');
        },
        setIndicatorData() {
            let selectedIndicator = this.selectedIndicatorId;
            var that = this;
            this.arrindicators.forEach( function(indicator)  {
                if (indicator.id == selectedIndicator) {
                    that.selectedIndicatorStr = indicator.indicatorString;
                    that.selectedIndicatorSlug = indicator.indicator;
                    that.selectedIndicator = indicator;
                }
            });
        },
        changeHospitalYear( year ) {
            console.log("changing year----------------" );
            console.log(this.groups)
            var hospital =  this.user.hospitals.find(h => h.year == year) 
            console.log(this.arrhospitals)
            this.groups.forEach( (group) => {
                group.group_year = year;
                console.log(group)
                if (group.group_name == 'My Peer Group') {
                    var myhosp = hospital;
                    console.log("current hospital")
                    console.log(myhosp)
                    console.log(this.getRevcatFromValue(myhosp.revcat))
                    group.group_netpatrev = this.getRevcatFromValue(myhosp.revcat);
                    group.group_ruralclinic = this.getHasrhcFromValue(myhosp.hasrhc);
                    group.group_longtermcare = this.getHassnfFromValue(myhosp.hassnf);
                    group.group_govtowned = this.getGovtFromValue(myhosp.govt);
                    console.log(group)
                }
            });
        }, 
        async fetchIndicators() {
            this.arrindicators = []
            try {
                let _indicators = await axios.get('/api/indicator_data/')
                    .then((response) => response.data)
                    this.arrindicators = _indicators[0]
            } catch (error) {
                this.error = error
                console.log(error)
            }
            this.loading = false
        },
        async fetchHospitals() {
            this.loading = true
            this.arrhospitals = []
            try {
                let _hospitals = await axios.get('/api/hospital_data/')
                    .then((response) => response.data)
                    this.arrhospitals = _hospitals
                    this.loading = false
            } catch (error) {
                this.error = error
                console.log(error)
                this.loading = false
            }
            this.loading = false
        },
        async fetchStates() {
            this.arrstates = []
            try {
                let _states = await axios.get('/api/state_data/')
                    .then((response) => response.data)
                    this.arrstates = _states
            } catch (error) {
                this.error = error
                console.log(error)
            }
            this.loading = false
        },
        async fetchVisData() {
            this.arrData = [];
            this.params = {};
            this.loading = true;
            this.params = {
                'type': this.chartType,
                'indicator': this.selectedIndicatorSlug,
                'indicatorString': this.selectedIndicatorStr,
                'usertype': this.user.typecode,
            }
            this.groups.forEach( (group, idx, theArray) => {
                if (group.index == 0) {
                    theArray[idx].index = idx+1; // start at 1 rather than 0
                }
            });

            this.groups.forEach( (group) => {
                let keyNameStart = 'group'+ group.index;
                var keys = Object.keys(group);

                keys.filter(v => v != 'index' ).forEach( ( key ) => {
                    
                        var keyStr = key;
                        keyStr = keyStr.replace('group', "");
                        keyStr = keyStr.replaceAll('_', "-");
                        let keyName = keyNameStart+keyStr;
                        this.params[keyName] = group[key];
                    
                    
                });
            });
            let params = this.params;


            try {
                if ( this.chartType == 'bar' ) {
                    var apiurl = '/barapi';
                    params['usertype'] = 'hospital';
                    params['myhospital'] = this.user.hospital;
                    
                } else if (this.chartType == 'line') {
                    var  apiurl = '/lineapi';
                } else if (this.chartType == 'fdi') {
                    var  apiurl = '/fdicatapi';
                } else {
                    var apiurl = '/barapi';
                    console.log('this.chartType is invalid: ' + this.chartType);
                }
                let _data = await axios.get(apiurl,  {params})
                    .then((response) => response.data)
                    this.arrData = _data
            } catch (error) {
                this.error = error
                console.log(error)
            }
            this.loading = false
        },

        getRevcat(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                case 1:
                    ret = 'Under 10m';
                    break;
                case 2:
                    ret = '10-20m';
                    break;
                case 3:
                    ret = 'Over 20m';
                    break;
                default:
                    ret = "";
                    break;
            }
            return ret;
        },
        getRevcatFromValue(input) { 
            var ret = "";
            switch (input) {
                case 'All':
                    ret = 0;
                    break;
                case 'Under 10m':
                    ret = 1;
                    break;
                case '10-20m':
                    ret = 2;
                    break;
                case 'Over 20m':
                    ret = 3;
                    break;
                default:
                    ret = "";
                    break;
            }
            return ret;
        },

        getGeo(input) { 
            var ret = "";
            switch (input) {
                case 'state':
                    ret = 'State';
                    break;
                case 'region':
                    ret = 'Region';
                    break;
                case 'national':
                    ret = 'National';
                    break;
                default:
                    ret = "";
                    break;
            }
            return ret;
        },

        getHasrhc(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                case 1:
                    ret = 'Has RHC';
                    break;
                case 2:
                    ret = 'No RHC';
                    break;
                default:
                    ret = "";
                    break;
            }
            return ret;

        },
        getHasrhcFromValue(input) { 
            var ret = "";
            switch (input) {
                case 'All':
                    ret = 0;
                    break;
                case 'Yes RHC':
                    ret = 1;
                    break;
                case 'No RHC':
                    ret = 2;
                    break;
                default:
                    ret = "";
                    break;
            }
            return ret;

        },


        getHassnf(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                case 1:
                    ret = 'Has LTC';
                    break;
                case 2:
                    ret = 'No LTC';
                    break;
                default:
                    ret = "";
                    break;
            }

            return ret;
        },

        getHassnfFromValue(input) { 
            var ret = "";
            switch (input) {
                case 'All':
                    ret = 0;
                    break;
                case 'Has LTC':
                    ret = 1;
                    break;
                case 'No LTC':
                    ret = 2;
                    break;
                default:
                    ret = "";
                    break;
            }

            return ret;
        },


        getGovt(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                case 1:
                    ret = 'Govt';
                    break;
                case 2:
                    ret = 'Nongovt';
                    break;
                default:
                    break;
            }

            return ret;
        },

        getGovtFromValue(input) { 
            var ret = "";
            switch (input) {
                case 'All':
                    ret = 0;
                    break;
                case 'Govt':
                    ret = 1;
                    break;
                case 'Nongovt':
                    ret = 2;
                    break;
                default:
                    break;
            }

            return ret;
        },

        getState(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                default:
                    ret = input;
                    break;
            }

            return ret;
        },

        getSystem(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                case 1:
                    ret = 'None';
                    break;
                default:
                    ret = "";
                    break;
            }

            return ret;
        },

        getRegion(input) { 
            var ret = "";
            switch (input) {
                case 0:
                    ret = 'All';
                    break;
                case 1:
                    ret = 'Northeast';
                    break;
                case 2:
                    ret = 'Midwest';
                    break;
                case 3:
                    ret = 'South';
                    break;
                case 4:
                    ret = 'West';
                    break;
                default:
                    ret = "";
                    break;
            }

            return ret;
        },

 
        
    },
})